// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';
import CertidaoNaoSubmissaoComponent from '../../components/products/certidao-nao-submissao/certidao-nao-submissao';
import CertidaoSubmissaoComponent from '../../components/products/certidao-submissao/certidao-submissao';
import { isMobileOnly } from 'react-device-detect';
import { Link } from 'react-router-dom';

// Primereact imports
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Badge } from 'primereact/badge';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './products.scss';

// Redux
import { connect } from 'react-redux';
import StoreService from '../../redux/services/store';

// Utils
import { APP_REF_AREA_MEMBROS, CERTIDAO_NAO_SUBMISSAO_PRODUCT, CERTIDAO_SUBMISSAO_PRODUCT } from '../../common/constants';

class PublicProductsPage extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            selectedProduct: null,
            products: [],
        };
    }

    componentDidMount() {
        // Prevent access to this page for authenticated users
        if(this.props.userId !== null) {
            window.open(process.env.PUBLIC_URL + "/products", "_self");
        }

        StoreService.getActiveProducts(true, false, false).then((response) => { 
            let formProducts = response.products;

            StoreService.getActiveProducts(false, true, true).then((resp) => { 

                for (let i = 0; i < resp.products.length; i++) {
                    formProducts.push(resp.products[i]);
                }

                this.setState({
                    products: formProducts
                })
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("products.messages.error"), life: 3000 });
            });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("products.messages.error"), life: 3000 });
        });
    }

    checkProductAvailability(productRef) {
        for (let i = 0; i < this.props.basketProducts.length; i++) {
            if(this.props.basketProducts[i].productRef === productRef) {
                return false;
            }            
        }

        return true;
    }

    selectProduct(product) {
        this.setState({selectedProduct: product});
    }

    addProductToBasketCallback() {
        this.setState({
            selectedProduct: null
        });

        window.scrollTo(0, 0);
        this._toast.current.show({ severity: 'success', detail: this.props.t("products.messages.product-added"), life: 3000 });
    }

    getProductTitle(productRef) {
        for (let i = 0; i < this.state.products.length; i++) {
            if(this.state.products[i].productRef === productRef) {
                return this.props.t("products.products." + this.state.products[i].title);
            }
        }

        return "";
    }

    render() {

       return (
            <div>
                <div>
                    {
                        localStorage.getItem('Hideinapp') === "1" ?
                            <div className="grid" style={{minHeight:"60px", alignItems:"center", background: "#0073AA", textAlign: "left"}}>
                                <div className="col-1"></div>
                                <div className="col-6">
                                    <span style={{color:"#FFFFFF", fontSize:"18px"}}>{this.props.t("products.title")}</span>
                                </div>
                                <div className="col-4 t-align-right" style={{paddingRight: "20px"}}>
                                    <Link to={process.env.PUBLIC_URL + "/checkout"}>
                                        {
                                            this.props.basketProducts.length === 0 ?
                                                <i className="pi pi-shopping-cart c-pointer" style={{ color: "#ffffff", fontSize: '1.9rem' }} title={this.props.t("checkout.menu")}></i>
                                                :
                                                <i className="pi pi-shopping-cart p-overlay-badge c-pointer" style={{ color: "#ffffff", fontSize: '1.9rem' }} title={this.props.t("checkout.menu")}>
                                                    <Badge style={{ borderColor: "#ffffff" }} value={this.props.basketProducts.length}></Badge>
                                                </i>
                                        }
                                    </Link>
                                </div>
                                <div className="col-1"></div>
                            </div>
                            :
                            <PageTitleComponent title={this.props.t("products.title")} />
                    }
                </div>
                <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                    <div className='col-1'></div>
                    <div className="col-10"> 
                        <div className='grid container mgt-20'>
                            {this.state.products.map((product) => {
                                return (
                                    product.form ?
                                        <div key={product.productRef} className="col-12 md:col-12 lg:col-3">
                                            <Card style={{color: "#0073aa", display: "flex", flexWrap: "wrap", alignContent: "space-between", flexDirection: "column", background: product.form ? "white" : "#ECECEC"}} 
                                                title={this.props.t("products.products." + product.title)}
                                                subTitle={product.subtitle !== null ? this.props.t("products.products." + product.subtitle) : null}
                                                footer={ <div className='grid' style={{marginTop: this.props.t("products.products." + product.title).length < 30 && (product.subtitle === null || product.subtitle === "") ? "40px" : "0px"}}>
                                                                <div style={{paddingTop: "15px"}} className='col-6 t-align-left'>
                                                                    {
                                                                        product.form ?
                                                                            <b style={{fontSize: "16px", marginTop: "10px", marginLeft: "10px"}}>{product.price === null ? this.props.t("products.labels.free") : product.price + "€"}</b>
                                                                            : 
                                                                            null
                                                                    }
                                                                </div>
                                                                <div className='col-6 t-align-right'>
                                                                    <div className="flex flex-wrap justify-content-end gap-2">
                                                                        <Button label={this.props.t("products.labels.add")} icon="pi pi-shopping-cart" disabled={!product.form || !this.checkProductAvailability(product.productRef)} onClick={(evt) => this.selectProduct(product)} />
                                                                    </div>
                                                                </div>
                                                            </div>} 
                                                header={<img alt="Card" src={"data:image/jpeg;base64," + product.picture} />} 
                                                className="md:w-25rem">
                                                <p className="m-0">
                                                </p>
                                            </Card>
                                        </div>
                                        : null
                                );
                            })}
                        </div>  
                        <div className='grid container mgt-20'>
                            <div className="col-12 md:col-12 lg:col-12 t-align-center">
                                <Button className='p-button-success' style={{fontSize: "20px"}} label={this.props.t("checkout.messages.close")} onClick={() => window.open(process.env.PUBLIC_URL + "/checkout", "_self")}  />
                            </div>
                        </div>  
                    </div>
                    <div className='col-1'></div>
                </div>
                {
                    this.state.selectedProduct !== null ?
                    <>
                        <Dialog visible={this.state.selectedProduct.productRef !== CERTIDAO_SUBMISSAO_PRODUCT && this.state.selectedProduct.productRef !== CERTIDAO_NAO_SUBMISSAO_PRODUCT} style={{ width: '450px' }} header={"Produto reservado a membros"} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <div className="grid mgt-10">
                                <div className="col-12" style={{fontSize: "14px"}}>
                                    <b>{this.props.t("products.labels.info-note")}</b>
                                </div>
                                <div className="col-12" style={{textAlign: "justify"}}>
                                    <ul style={{marginLeft: "20px", padding: 0}}>
                                        <li style={{marginBottom: "10px"}}>{this.props.t("products.labels.internal-products")}</li>
                                    </ul>
                                </div>
                                <div className='col-12 t-align-right'>
                                    <div className="flex flex-wrap justify-content-end gap-2">  
                                        <Button label="Autenticar" icon="pi pi-user" onClick={(evt) => window.open(process.env.REACT_APP_OF_PORTAL_URL + "of-auth/?app_ref=" + APP_REF_AREA_MEMBROS, "_blank") }/>
                                    </div>
                                </div>
                            </div>
                        </Dialog>
                        <Dialog visible={this.state.selectedProduct.productRef === CERTIDAO_NAO_SUBMISSAO_PRODUCT} style={{ width: '160vh' }} header={this.getProductTitle(CERTIDAO_NAO_SUBMISSAO_PRODUCT)} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <CertidaoNaoSubmissaoComponent product={this.state.selectedProduct} onClose={() => this.addProductToBasketCallback()} />
                        </Dialog>
                        <Dialog visible={this.state.selectedProduct.productRef === CERTIDAO_SUBMISSAO_PRODUCT} style={{ width: '160vh' }} header={this.getProductTitle(CERTIDAO_SUBMISSAO_PRODUCT)} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <CertidaoSubmissaoComponent product={this.state.selectedProduct} onClose={() => this.addProductToBasketCallback()} />
                        </Dialog>
                    </>
                    :
                    null
                }
                <Toast position='bottom-left' ref={this._toast} />
            </div>
        );
  }
}

const mapStateToProps = (state) => {
    return {
        userId: state.authentication.userId,
        ballot: state.profile.ballot,
        registrationState: state.authentication.registrationState,
        basketProducts: state.store.basketProducts
    } 
};

export default connect(mapStateToProps, undefined)(withTranslation(PublicProductsPage));